import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
// import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "CreateSuplePage",
  data() {
    let ss = new MainService();
    return {
      msg: "CreateSuplePage",
      ss: ss,
      ajax: {
        url: ss.indexCreateSuple(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N°",
          orderable: false,
          searchable: false,
        },
        { data: "paterno", name: "paterno", title: "Paterno" },
        { data: "materno", name: "materno", title: "Materno" },
        { data: "nombre", name: "nombre", title: "Nombre" },
        { data: "ci", name: "ci", title: "CI" },
        { data: "motivo", name: "motivo", title: "Certificado" },
        { data: "carrera.Carrera", name: "Carrera", title: "Carrera" },
        {
          data: "action",
          orderable: false,
          title: "Acciones",
          searchable: false,
        },
      ],
      createsuples: [],
      createsuple: {},
      isLoading: false,
      errorBag: {},
      gestion: null,
      notaTotal: null,
      carrera: "",
      unidadAcademica: "",
      evaluadores: "",
      instituciones: "",
      idiomas: "",
    };
  },
  methods: {
    showCreateSuple(id) {
      this.isLoading = true;
      this.ss
        .showCreateSuple(id)
        .then((result) => {
          let response = result.data;
          this.createsuple = response.data;
          this.gestion = response.gestion;
          this.instituciones = response.instituciones;
          this.evaluadores = response.evaluadores;
          this.carrera = response.carrera;
          this.idiomas = response.idiomas;
          this.unidadAcademica = response.unidadAcademica;
          this.notaTotal = response.notaTotal;
          this.$refs["view-createsuple"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    editCreateSuple() {
      this.$refs["frm-createsuple"].show();
      this.$refs["view-createsuple"].hide();
    },
    cancelCreateSuple() {
      if (this.createsuple.id) {
        this.$refs["view-createsuple"].show();
      }
      this.$refs["frm-createsuple"].hide();
    },
    saveCreateSuple() {
      // Obtener el archivo seleccionado
      let file = document.querySelector('input[type="file"]').files[0];

      // Crear un FormData para enviar el archivo al backend
      let formData = new FormData();
      formData.append("File", file);

      // Enviar el archivo al backend utilizando la función uploadFile
      this.ss
        .uploadFile(formData)
        .then((response) => {
          this.createsuple.pdf = response.data.data;
          // Guardar la instancia
          this.ss
            .storeCreateSuple(this.createsuple)
            .then((result) => {
              let response = result.data;
              this.$bvToast.toast(response.msg, {
                title: "Correcto",
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["frm-createsuple"].hide();
              this.$refs["datatable-createsuple"].reload();
            })
            .catch((error) => {
              this.errorBag = error.response.data.errors;
              this.$bvToast.toast(
                "Problema al Guardar el Registro, favor verificar los Datos",
                {
                  title: "Error",
                  variant: "danger",
                  autoHideDelay: 5000,
                }
              );
            });
        })
        .catch((error) => {
          // Aquí puedes manejar los errores, por ejemplo, mostrar un mensaje de error al usuario
        });
    },

    deleteCreateSuple() {
      this.$swal({
        title: "¿Estás seguro que deseas eliminar?",
        text: "Esta acción es irreversible!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.ss
            .destroyCreateSuple(this.createsuple)
            .then((result) => {
              let response = result.data;
              this.$swal({
                title: "¡Eliminado!",
                text: "El archivo ha sido eliminado.",
                icon: "success",
              });
              this.$refs["view-createsuple"].hide();
              this.$refs["datatable-createsuple"].reload();
            })
            .catch((error) => {
            });
        }
      });
    },
    createCreateSuple() {
      this.errorBag = {};
      this.createsuple.gestion = document.querySelector(
        'input[name="gestion"]'
      ).value;
      this.createsuple.motivo_anterior = document.querySelector(
        'input[name="motivo_anterior"]'
      ).value;
      this.createsuple.nota_d = document.querySelector(
        'input[name="nota_d"]'
      ).value;

      this.ss
        .createcertCreateSuple(this.createsuple)
        .then((response) => {
          window.open(response.data.pdf_url);
          this.$refs["frm-createsuple"].show();
          this.$refs["view-createsuple"].hide();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(
            "Problema al Crear el Certificado, favor verificar los Datos",
            {
              title: "Error",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },
    draw() {
      window.$(".btn-datatable-CreateSuple").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showCreateSuple(data);
      });
    },
  },
  components: {
    dataTable,
    // Loader
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Login");
    }
  },
};
